import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const Detail = lazy(() => import('./components/Detail'))
const List = lazy(() => import('./components/List'))
const New = lazy(() => import('./components/New'))

const PromoModule: RouteObject = {
    path: 'promos',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'new',
            element: <New />,
        },
        {
            path: ':id',
            element: <Detail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default PromoModule
